__turbopack_context__.v({
  "className": "public_sans_1e7297dc-module__O1LqGa__className",
});
